import React from 'react';
import { Link } from 'react-router-dom';
import ReactTypingEffect from 'react-typing-effect';
import profilepic from '../img/reece_photo.webp';
import profilepicFormal from '../img/reece_headshot.webp';
import bgVideo from '../img/bg.mp4';
import Social from '../components/Social';

function Home() {
    return (
        <div className="condiv home">
            <div className="hero-video-bg" aria-hidden="true">
                <video className="hero-video" autoPlay loop muted playsInline>
                    <source src={bgVideo} type="video/mp4" />
                </video>
                <div className="hero-video-overlay"></div>
            </div>
            <div className="hero-content">
                <p className="eyebrow">Hello, I&apos;m</p>
                <div className="profilepic-flip">
                    <div className="profilepic-flip-inner">
                        <img src={profilepic} alt="Reece Lardy" className="profilepic profilepic-front" />
                        <img
                            src={profilepicFormal}
                            alt="Reece Lardy, professional headshot"
                            className="profilepic profilepic-back"
                        />
                    </div>
                </div>
                <h1 className="hero-name">Reece Lardy</h1>
                <ReactTypingEffect
                    className="typingeffect"
                    text={['Software Engineer', 'Computer Engineer', 'Full-Stack Developer']}
                    speed={100}
                    eraseDelay={700}
                />
                <p className="hero-tagline">
                    Engineering clean, maintainable solutions for ambiguous technical problems. My
                    approach combines deep foundational software practices with modern AI
                    application development, transforming complex business requirements into
                    intelligent, secure, and highly scalable digital products.
                </p>
                <div className="hero-actions">
                    <Link className="btn btn-primary" to="/contact">
                        Get in touch
                    </Link>
                    <a
                        className="btn btn-secondary"
                        href="https://github.com/rjlardy21"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View GitHub
                    </a>
                </div>
                <Social />
            </div>
        </div>
    );
}

export default Home;
